import React, { useEffect, useState } from "react";
import { Activity, Database, Gauge, RadioTower, RefreshCw, SatelliteDish, Server } from "lucide-react";
import { fetchNWSActive } from "../../utils/nws";
import { useStudioAuth } from "../StudioAuthContext";
import { Panel, StatusChip } from "../ui";

export const SystemSection = () => {
  const { request } = useStudioAuth();
  const [system, setSystem] = useState(null);
  const [nws, setNws] = useState({ status: "checking", alerts: 0 });

  const load = async () => {
    try {
      const [response, alerts] = await Promise.all([request("/operations/system"), fetchNWSActive()]);
      if (response.ok) setSystem(await response.json());
      setNws({ status: "online", alerts: alerts.length });
    } catch (_) {
      setNws({ status: "offline", alerts: 0 });
    }
  };
  useEffect(() => { load(); const timer = setInterval(load, 15000); return () => clearInterval(timer); }, [request]); // eslint-disable-line react-hooks/exhaustive-deps

  const rows = [
    { key: "api", label: "Control API", icon: Server, status: system?.api },
    { key: "database", label: "MongoDB", icon: Database, status: system?.database },
    { key: "weatherfront", label: "Storm Desk Radar", icon: SatelliteDish, status: system?.weatherfront_embed },
    { key: "nws", label: "NWS Alerts", icon: Activity, status: nws.status, note: `${nws.alerts} active` },
    { key: "relay", label: "Media Relay", icon: RadioTower, status: system?.relay },
  ];

  return (
    <Panel
      title="Service Health"
      icon={Gauge}
      note={`Last check: ${system?.checked_at ? new Date(system.checked_at).toLocaleTimeString() : "pending"}`}
      actions={
        <button data-testid="system-refresh-button" onClick={load} title="Run check" className="grid h-7 w-7 place-items-center border border-white/10 text-slate-400 transition-colors hover:bg-white/5 hover:text-white">
          <RefreshCw className="h-3.5 w-3.5" />
        </button>
      }
      bodyClass="p-0"
    >
      <div className="divide-y divide-[rgba(120,170,255,0.12)]">
        {rows.map(({ key, label, icon: Icon, status, note }) => {
          const online = ["online", "configured", "standby"].includes(status);
          const blocked = status === "blocked" || status === "offline";
          return (
            <div key={key} data-testid={`system-${key}-status`} className="flex items-center justify-between gap-4 px-4 py-3">
              <div className="flex min-w-0 items-center gap-3">
                <div className="grid h-8 w-8 shrink-0 place-items-center border border-white/10 text-slate-300"><Icon className="h-4 w-4" /></div>
                <div className="min-w-0">
                  <div className="truncate text-sm font-bold text-white">{label}</div>
                  {note && <div className="mono text-[9px] uppercase tracking-widest text-slate-600">{note}</div>}
                </div>
              </div>
              <StatusChip state={online ? "ok" : blocked ? "blocked" : "idle"}>{status || "checking"}</StatusChip>
            </div>
          );
        })}
      </div>
    </Panel>
  );
};

export default SystemSection;
